import { setPageTitle } from "../store/actions/pageTitleSlice";
import store from "../store/store";

export const setPageTitleState = (pathname) => {
  switch (pathname) {
    case "/change-password":
      store.dispatch(setPageTitle("Alterar Senha | Slapie"));
      break;
    case "/central-delivery":
      store.dispatch(setPageTitle("Central Delivery | Slapie"));
      break;
    case "/central-salao":
      store.dispatch(setPageTitle("Central Salão | Slapie"));
      break;
    case "/central-embalagem":
      store.dispatch(setPageTitle("Central Embalagem | Slapie"));
      break;
    case "/delivery-center":
      store.dispatch(setPageTitle("Operação | Slapie"));
      break;
    case "/cashier":
      store.dispatch(setPageTitle("Caixas | Slapie"));
      break;
    case "/fiscal":
      store.dispatch(setPageTitle("Notas Fiscais | Slapie"));
      break;
    case "/drivers":
      store.dispatch(setPageTitle("Entregadores | Slapie"));
      break;
    case "/historico/pedidos":
      store.dispatch(setPageTitle("Histórico Pedidos | Slapie"));
      break;
    case "/historico/entregas":
      store.dispatch(setPageTitle("Histórico Entregas | Slapie"));
      break;
    case "/reports":
      store.dispatch(setPageTitle("Relatórios | Slapie"));
      break;
    case "/products":
      store.dispatch(setPageTitle("Produtos | Slapie"));
      break;
    case "/customers":
      store.dispatch(setPageTitle("Clientes | Slapie"));
      break;
    case "/restaurant/new":
      store.dispatch(setPageTitle("Novo Restaurante | Slapie"));
      break;
    case "/restaurant/:id":
      store.dispatch(setPageTitle("Restaurante | Slapie"));
      break;
    default:
      store.dispatch(setPageTitle("Central Delivery | Slapie"));
      break;
  }
};

export const setIdUrlQueryParam = (id, location, history) => {
  // Create a new URLSearchParams object based on the current URL
  const searchParams = new URLSearchParams(location.search);

  if (id) {
    // Set the id as a query param
    searchParams.set("id", id);
  } else {
    // If shippingRouteId is falsy, remove the 'id' query param
    searchParams.delete("id");
  }

  // Update the URL with the new search params
  history.push({
    pathname: location.pathname,
    search: `?${searchParams.toString()}`, // Append updated search params to the URL
  });
};
